import PropTypes from 'prop-types';

import { Announcement, HelpV2Icon, InfoFilledIcon, OverlayTriggerTooltip } from '@utilities';

import { getQuestionCost } from '../../../../../../utilities/helpers';

import styles from './_index.module.scss';

const GridAnnouncement = ({ question }) => {
  const questionCost = getQuestionCost(question);

  return (
    <Announcement
      className={styles['grid-announcement']}
      icon={<InfoFilledIcon />}
      text={
        <>
          <strong>
            This will count as {questionCost} question{questionCost !== 1 ? 's' : ''} for your
            survey.
          </strong>{' '}
          <OverlayTriggerTooltip content="This is to improve the quality of data and the panelist experience; the time and effort required to answer 4 rows in a grid is similar to answering a single longer multi-select or open-ended question.">
            <HelpV2Icon className={styles['grid-announcement-help-icon']} />
          </OverlayTriggerTooltip>
        </>
      }
      variant="info"
    />
  );
};

GridAnnouncement.propTypes = {
  question: PropTypes.object.isRequired,
};

export default GridAnnouncement;
